import { AndroidOutlined, AppleOutlined, IosOutlined, LinuxOutlined, WindowsOutlined } from "@payping/icons";
import { Tooltip } from "@payping/web-components";
import React from "react";
import { safeJoinPath } from "@payping/utils/string";
import { webConstants } from "@payping/utils/platformConstants";

export const appIcons: React.ReactNode[][] = [
  [
    <a key={0} href={safeJoinPath(webConstants.PPNG, "t/linux")}>
      <Tooltip title={"Linux"}>
        <LinuxOutlined width={"24px"} />
      </Tooltip>
    </a>,
    <a key={1} href={safeJoinPath(webConstants.PPNG, "t/yt0q")}>
      <Tooltip title={"MacOS"}>
        <AppleOutlined width={"24px"} />
      </Tooltip>
    </a>,
    <a key={2} href={safeJoinPath(webConstants.PPNG, "t/windows")}>
      <Tooltip title={"Windows"}>
        <WindowsOutlined width={"24px"} />
      </Tooltip>
    </a>,
  ],
  [
    <a key={3} href={safeJoinPath(webConstants.PPNG, "t/12SE")}>
      <Tooltip title={"IOS"}>
        <IosOutlined width={"24px"} />
      </Tooltip>
    </a>,
    <a key={4} href={safeJoinPath(webConstants.PPNG, "t/android")}>
      <Tooltip title={"Android"}>
        <AndroidOutlined width={"24px"} />
      </Tooltip>
    </a>,
  ],
];
